import { render, staticRenderFns } from "./collector.vue?vue&type=template&id=ade47992&scoped=true"
import script from "./collector.vue?vue&type=script&lang=js"
export * from "./collector.vue?vue&type=script&lang=js"
import style0 from "./collector.vue?vue&type=style&index=0&id=ade47992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade47992",
  null
  
)

export default component.exports